<button
  type="button"
  class="option-card"
  [attr.aria-label]="title() + '. ' + description()"
  (click)="activate()"
  (keydown)="onKeydown($event)"
>
  <span class="option-card__icon" aria-hidden="true">
    <img [src]="'assets/icons/' + icon() + '.svg'" alt="" />
  </span>
  <span class="option-card__content">
    <span class="option-card__title">{{ title() }}</span>
    <span class="option-card__description">{{ description() }}</span>
  </span>
  <span class="option-card__chevron" aria-hidden="true"></span>
</button>
